export default __webpack_public_path__ + "static/media/picture-selfie.0dbf5f24.png";